import {Parcel} from '../../_models/parcel';
import {FileOnlineUtil} from './FileOnlineUtil';
import {Subject} from 'rxjs';
import {ModalAlertMessage} from './models/ModalAlertMessage';

export class FileOnlineViewModel {
  // Modal listener
  modalAlertMessage: ModalAlertMessage | null = null; // Can be set by any component to send a simple alert
  modalTriggerSubject = new Subject<ModalAlertMessage>();
  modalTriggerObservable = this.modalTriggerSubject.asObservable();
  // Caches address searches & individual AIN lookups
  parcelCache = new Map<string, Parcel>();
  // Parcels the filer interacted with and attached to this submission
  parcels: Parcel[] = [];
  private uniqueParcels = new Set<string>();

  getCachedParcel(ain: string): Parcel {
    return this.parcelCache.get(ain.replace(/-/g, ''));
  }

  cacheParcel(ain: string, parcel: Parcel): void {
    this.parcelCache.set(ain.replace(/-/g, ''), parcel);
  }

  addParcel(parcel: Parcel): void {
    const ain = FileOnlineUtil.stripDashes(parcel.AIN);
    if (!this.uniqueParcels.has(ain)) {
      this.uniqueParcels.add(ain);
      this.parcels.push(parcel);
    }
  }

  removeParcel(ain: string): void {
    const strippedAin = FileOnlineUtil.stripDashes(ain);
    this.uniqueParcels.delete(strippedAin);
    this.parcels = this.parcels.filter((value) => FileOnlineUtil.stripDashes(value.AIN) !== strippedAin);
  }
}
